import { Routes } from '@angular/router';
import { SiaWorkflowConfiguratorComponent } from './components/sia-workflow-configurator/sia-workflow-configurator.component';
import { SiaAIFilesGridComponent } from './pages/ai-files-grid/ai-files-grid.component';
import { SiaAiAssistantComponent } from './pages/ai-assistant/ai-assistant.component';

export const ROUTES: Routes = [
  {
    path: 'ai-workflow/:componentId/:guid',
    component: SiaWorkflowConfiguratorComponent,
  },
  {
    path: 'ai-files-grid/:guid',
    component: SiaAIFilesGridComponent,
  },
  {
    path: 'ai-assistant/:guid',
    component: SiaAiAssistantComponent,
  },
];
